// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./Utilities/RecoilAtomsV2.bs.js";
import * as WalletElement$OrcaPaymentPage from "./WalletElement.bs.js";
import * as WalletShimmer$OrcaPaymentPage from "./Components/WalletShimmer.bs.js";
import * as PaymentElement$OrcaPaymentPage from "./PaymentElement.bs.js";
import * as PaymentElementV2$OrcaPaymentPage from "./PaymentElementV2.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./Components/PaymentElementShimmer.bs.js";

function PaymentElementRenderer(props) {
  var cvcProps = props.cvcProps;
  var expiryProps = props.expiryProps;
  var cardProps = props.cardProps;
  var paymentType = props.paymentType;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$1.localeString;
  var setFullName = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userFullName);
  var setNickName = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userCardNickName);
  var match$2 = React.useTransition();
  var startTransition = match$2[1];
  React.useEffect((function () {
          startTransition(function () {
                setFullName(function (prev) {
                      return Utils$OrcaPaymentPage.validateName("", prev, localeString);
                    });
                setNickName(function (prev) {
                      return Utils$OrcaPaymentPage.setNickNameState("", prev, localeString);
                    });
              });
        }), []);
  var isLoading;
  switch (paymentType) {
    case "Payment" :
        isLoading = typeof paymentMethodList !== "object" && paymentMethodList === "Loading" ? true : false;
        break;
    case "PaymentMethodsManagement" :
        isLoading = typeof paymentManagementList !== "object" && paymentManagementList === "LoadingV2" ? true : false;
        break;
    default:
      isLoading = false;
  }
  var isWalletElement = Utils$OrcaPaymentPage.checkIsWalletElement(paymentType);
  if (isLoading) {
    return React.createElement(RenderIf$OrcaPaymentPage.make, {
                condition: match.showLoader,
                children: isWalletElement ? React.createElement(WalletShimmer$OrcaPaymentPage.make, {}) : React.createElement(PaymentElementShimmer$OrcaPaymentPage.make, {})
              });
  } else if (isWalletElement) {
    return React.createElement(WalletElement$OrcaPaymentPage.make, {
                paymentType: paymentType
              });
  } else if (paymentType === "PaymentMethodsManagement") {
    return React.createElement(PaymentElementV2$OrcaPaymentPage.make, {
                cardProps: cardProps,
                expiryProps: expiryProps,
                cvcProps: cvcProps,
                paymentType: paymentType
              });
  } else {
    return React.createElement(PaymentElement$OrcaPaymentPage.make, {
                cardProps: cardProps,
                expiryProps: expiryProps,
                cvcProps: cvcProps,
                paymentType: paymentType
              });
  }
}

var $$default = PaymentElementRenderer;

export {
  $$default as default,
}
/* react Not a pure module */
